import {
  BoundingPoly,
  BoundingPolyRect,
} from '@common-modules/mediaDetails/models/BoundingPoly';
import { GROUPED_POLY_TYPE } from '@helpers/constants';

export type GroupedBoundingPoly = Omit<
  BoundingPoly,
  'engineId' | 'size' | 'object'
> & {
  readonly groupId: string;
  readonly clusterId?: string | undefined; // may require later?
  // readonly label?: string;
  readonly type: GROUPED_POLY_TYPE;
  readonly boundingPoly: BoundingPolyRect;
  readonly isDeleted: boolean;
  readonly isEditable: boolean;
  readonly readOnly?: boolean;
};

// this class is used for heapsnapshot analysis.
export class CollectionWrapper {
  collection: BoundingPolyTree;
  constructor(collection: BoundingPolyTree) {
    this.collection = collection;
  }
}

export interface BoundingPolyTree {
  readonly bins: { [key: number]: Array<GroupedBoundingPoly> };
  readonly binsPerSecond: number;
  version: number;
  start: number;
  end: number;
  readonly groups: { [groupId: string]: Array<GroupedBoundingPoly> };
  readonly fps: number | undefined;
}

export type Searcher = (
  c: BoundingPolyTree | undefined,
  mark: number,
  isRect?: boolean,
  prePos?: number
  // ) => ReadonlyArray<GroupedBoundingPoly>;
) => Array<GroupedBoundingPoly>;

// below are the legacy data structures

// export interface BoundingPolyTree {
//   readonly left?: BoundingPolyTree;
//   readonly right?: BoundingPolyTree;
//   readonly start: number;
//   readonly end: number;
//   readonly ms: number;
//   readonly value?: ReadonlyArray<GroupedBoundingPoly>;
//   version?: number;
// }

// export type Factory = (
//   fps: number,
//   mediaSpan: [number, number],
//   version: number
// ) => (
//   ps: ReadonlyArray<GroupedBoundingPoly>,
//   isRoot?: boolean,
//   seedCollection?: BoundingPolyTree,
//   period?: [number, number]
// ) => BoundingPolyTree | undefined;

// export type Splitter = (p: [number, number]) => [number, number, number];

// export type Searcher = (
//   c: BoundingPolyTree | undefined,
//   mark: number,
//   isRect?: boolean,
//   prePos?: number
// ) => ReadonlyArray<GroupedBoundingPoly>;
